export class C_GameTypes {
  alternativeHandicaps: number[];
  alternativeTotals: number[];
  american_football: number[];
  anticipadas: number[];
  apuestas_especiales: number[];
  artes_marciales: number[];
  australian_football: number[];
  badminton: number[];
  baseball_jp: number[];
  baseball_kr: number[];
  baseball_us: number[];
  baseball: number[];
  basketball_us: number[];
  basketball: number[];
  beach_soccer: number[];
  beach_volleyball: number[];
  boxeo: number[];
  curling: number[];
  darts: number[];
  ebasket: number[];
  edgeCases: any;
  efootball: number[];
  eSports_sports: number[];
  esports: number[];
  field_hockey: number[];
  futsal: number[];
  gameTypesData: any;
  handball: number[];
  ice_hockey_nous_live: number[];
  ice_hockey_us: number[];
  ice_hockey: number[];
  motorsport: number[];
  padel: number[];
  pelota: number[];
  rugby_league: number[];
  rugby: number[];
  snooker: number[];
  soccer: number[];
  squash: number[];
  table_tennis: number[];
  tennis: number[];
  videolive: number[];
  virtual_soccer: number[];
  volleyball: number[];
  waterpolo: number[];
  constructor(gameTypesData?: any) {
    if (gameTypesData) {
      this.gameTypesData = gameTypesData;
      this.setGameTypesData(gameTypesData);
    }
  }

  public setVideoLive() {
    this.videolive = Object.keys(this).reduce((acc, key) => {
      if (this[key] && !["videolive", "gameTypesData", "edgeCases"].includes(key)) {
        acc.push(...this[key]);
      }
      const set = new Set(acc);
      return Array.from(set);
    }, []);
  }

  getAll(): number[] {
    return [...this.videolive, ...this.getAllEdgeCases()];
  }

  //-> EventoPage --> Outputs: getOne(ice_hockey,nous,true) -> // [1, 18]
  getOne(
    sportHandle: string,
    countryCode: string,
    isLive?: boolean,
    league?: string,
    auxGameTypes?: number[],
  ): number[] {
    //-> si country Code
    //-> si es live;
    // si no, sporthandle;
    if (this.isEdgeCase(sportHandle, league)) {
      return this.getEdgeCase(sportHandle, league);
    }

    let gametype = sportHandle;
    const gameTypes = this;
    if (countryCode) {
      //ice_hockey_us
      countryCode = sportHandle === "ice_hockey" && isLive ? "nous" : countryCode; // Todo: needs refactor.
      gametype = gametype + "_" + countryCode.toLowerCase(); //?
    }

    if (isLive && Object.prototype.hasOwnProperty.call(gameTypes, gametype + "_live")) {
      gametype = gametype + "_live";
    }

    if (Object.prototype.hasOwnProperty.call(gameTypes, "gametype") && sportHandle !== "basketball") {
      // if (gameTypes.hasOwnProperty(gametype) && sportHandle !== 'basketball') {
      return gameTypes[gametype];
      // } else if ((sportHandle === 'basketball' || sportHandle === "ice_hockey") && !!auxGameTypes && auxGameTypes.length >= 3) {
    } else if (sportHandle === "basketball" && !!auxGameTypes && auxGameTypes.length >= 1) {
      const setGametypes = this.setBasketballGametypes(auxGameTypes, gameTypes, sportHandle);
      return setGametypes;
    } else {
      return gameTypes[sportHandle];
    }
  }

  setBasketballGametypes(auxGameTypes, gameTypes, sportHandle: string) {
    if (auxGameTypes.length >= 3) {
      return auxGameTypes.slice(0, 3);
    } else {
      let customMatrix: number[] = [];
      if (gameTypes[sportHandle]) {
        customMatrix = [...gameTypes[sportHandle]];
        auxGameTypes?.map((gameType) => {
          if (gameType === 97 || gameType === 184) {
            customMatrix[0] = gameType;
          } else if (gameType === 159 || gameType === 259) {
            customMatrix[1] = gameType;
          } else if (gameType === 18 || gameType === 393 || gameType === 2083) {
            customMatrix[2] = gameType;
          }
        });
      }
      return customMatrix;
    }
  }

  //DirectosPage, TodayPage?, SportEventsPage and rest of Overviews
  getSport(sportHandle: string): number[] {
    const sport = Object.keys(this).reduce((acc, key) => {
      if (key !== "edgeCases" && key.includes(sportHandle)) {
        acc.push(...this[key]);
      }
      return acc;
    }, []);

    let edgeCases = [];
    if (this.edgeCases[sportHandle]) {
      edgeCases = this.edgeCases[sportHandle].reduce((acc, [_, games]) => [...acc, ...games], []);
    }

    return Array.from(new Set([...sport, ...edgeCases]));
  }

  serialize(gameTypes: number[]) {
    gameTypes = Array.from(new Set(gameTypes));
    return gameTypes.reduce((acc, type) => (acc += type + ";"), "").slice(0, -1);
  }

  isSpecial(gameType: number): boolean {
    return this.apuestas_especiales.indexOf(gameType) !== -1;
  }

  getAllEdgeCases() {
    const edgeCases = [];

    Object.keys(this.edgeCases).forEach((key) => {
      const sport = this.edgeCases[key].reduce((acc, [_, games]) => [...acc, ...games], []);
      edgeCases.push(...sport);
    });

    return edgeCases;
  }

  getEdgeCase(sportHandle: string, league: string): number[] {
    const tuple = this.edgeCases[sportHandle].find((element) => element[0].indexOf(parseInt(league)) !== -1);

    return tuple[1];
  }

  isEdgeCase(sportHandle: string, league: string): boolean {
    if (!this.edgeCases[sportHandle] || !league) {
      return false;
    }

    return this.edgeCases[sportHandle].some(([leagues]) => leagues.indexOf(parseInt(league)) !== -1);
  }

  setGameTypesData(gameTypesData: any) {
    this.alternativeHandicaps = gameTypesData.gametypes.alternativeHandicaps;
    this.alternativeTotals = gameTypesData.gametypes.alternativeTotals;
    this.american_football = gameTypesData.gametypes.american_football;
    this.anticipadas = gameTypesData.gametypes.anticipadas;
    this.apuestas_especiales = gameTypesData.gametypes.apuestas_especiales;
    this.artes_marciales = gameTypesData.gametypes.artes_marciales;
    this.australian_football = gameTypesData.gametypes.australian_football;
    this.badminton = gameTypesData.gametypes.badminton;
    this.baseball = gameTypesData.gametypes.baseball;
    this.baseball_jp = gameTypesData.gametypes.baseball_jp;
    this.baseball_kr = gameTypesData.gametypes.baseball_kr;
    this.baseball_us = gameTypesData.gametypes.baseball_us;
    this.basketball = gameTypesData.gametypes.basketball;
    this.basketball_us = gameTypesData.gametypes.basketball_us;
    this.beach_soccer = gameTypesData.gametypes.beach_soccer;
    this.beach_volleyball = gameTypesData.gametypes.beach_volleyball;
    this.boxeo = gameTypesData.gametypes.boxeo;
    this.curling = gameTypesData.gametypes.curling;
    this.darts = gameTypesData.gametypes.darts;
    this.ebasket = gameTypesData.gametypes.ebasket;
    this.efootball = gameTypesData.gametypes.efootball;
    this.esports = gameTypesData.gametypes.esports;
    this.eSports_sports = gameTypesData.gametypes.eSports_sports;
    this.field_hockey = gameTypesData.gametypes.field_hockey;
    this.futsal = gameTypesData.gametypes.futsal;
    this.handball = gameTypesData.gametypes.handball;
    this.ice_hockey = gameTypesData.gametypes.ice_hockey;
    this.ice_hockey_nous_live = gameTypesData.gametypes.ice_hockey_nous_live;
    this.ice_hockey_us = gameTypesData.gametypes.ice_hockey_us;
    this.motorsport = gameTypesData.gametypes.motorsport;
    this.padel = gameTypesData.gametypes.padel;
    this.pelota = gameTypesData.gametypes.pelota;
    this.rugby = gameTypesData.gametypes.rugby;
    this.rugby_league = gameTypesData.gametypes.rugby_league;
    this.snooker = gameTypesData.gametypes.snooker;
    this.soccer = gameTypesData.gametypes.soccer;
    this.squash = gameTypesData.gametypes.squash;
    this.table_tennis = gameTypesData.gametypes.table_tennis;
    this.tennis = gameTypesData.gametypes.tennis;
    this.virtual_soccer = gameTypesData.gametypes.virtual_soccer;
    this.volleyball = gameTypesData.gametypes.volleyball;
    this.waterpolo = gameTypesData.gametypes.waterpolo;

    this.setVideoLive();

    this.edgeCases = gameTypesData.edgeCases;
  }
}
